import { render, staticRenderFns } from "./boxList.vue?vue&type=template&id=0fe591df&scoped=true&"
import script from "./boxList.vue?vue&type=script&lang=js&"
export * from "./boxList.vue?vue&type=script&lang=js&"
import style0 from "./boxList.vue?vue&type=style&index=0&id=0fe591df&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe591df",
  null
  
)

export default component.exports